import { ORDER_TEMP } from "../apis/cabinet";

export default {
  methods: {
    // 用户余额租借
    onUseBalanceToRent(productId) {
      this.$loading(true);
      this.$get(
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}&rentalProductType=${productId}`,
        {},
        resp => {
          this.$loading(false);
          console.log(resp);
          if (resp.data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${resp.data.outTradNo}&shopid=${this.cabinet.shopid}`
            );
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            });
          }
        },
        error => {
          this.$loading(false);
          console.log(error);
          this.$toast(error);
        }
      );
    },
    // 选择租借产品类型
    rentalProductType(cabinet) {
      this.$loading(true);
      let isProduct1 =
        cabinet.supportRentalProductType != null &&
        cabinet.supportRentalProductType.includes("1") &&
        cabinet.ordinaryPowerBankAvailable;
      let isProduct2 =
        cabinet.supportRentalProductType != null &&
        cabinet.supportRentalProductType.includes("2") &&
        cabinet.fastChargePowerBankAvailable;
      let type = "";
      if (isProduct1 && isProduct2) {
        type = cabinet.defaultRentalProductType;
      } else if (isProduct2) {
        type = "2";
      } else if (isProduct1) {
        type = "1";
      }
      return type;
    }
  }
};
